import React, { useEffect, useState, useContext, useMemo } from "react";

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory, Link } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
// import socket from '../componentes/Socket';
import Menu from "../componentes/Menu";
import { FacturaElectronica } from "./FacturaElectronica";
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";

// Contexto
import dataContext from "../context/User";
// Helper
import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";

const PasantiasAlumnos = () => {
  const history = useHistory();
  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem("dataUser");

  const [pasantias, setPasantias] = useState();
  const [cv, setCV] = useState(0);
  const [cargando, setCargando] = useState(true);
  // Filtros
  const [busqueda, setBusqueda] = useState("");
  const [areaFiltro, setAreaFiltro] = useState("");
  const [empresaFiltro, setEmpresaFiltro] = useState("");
  const [aplicacionFiltro, setAplicacionFiltro] = useState("");

  if (datos) {
    let cred = JSON.parse(datos);
    dataUser.token = cred.token;
    dataUser.nombre = cred.nombre;
    dataUser.carnet = cred.carnet;
    dataUser.email = cred.correo;
  } else {
    history.push("/");
  }

  useEffect(() => {

    let dataPasantias = () => {
      GetFetch.getPasantiaAll(dataUser.token).then((pasantiaData) => {
        setPasantias(pasantiaData);
        alertaVisualNotiPasantias(pasantiaData);
        setCargando(false);
      }).catch(() => setCargando(false));
    };

    dataPasantias();

    const data = new FormData();
    data.append("carnet", dataUser.carnet);
    GetFetch.fileValidarCVPasantia(data, dataUser.token).then(datos=>{
      setCV(datos.success);
    })

    let alertaVisualNotiPasantias = (dataPasantias)=>{
      let alertaNoti = localStorage.getItem('alertaPasantiasLocal');
      if (alertaNoti) {
          //Recorriendo el resultado de notificaciones de la nube
          let tempNoti = JSON.parse(alertaNoti);
          dataPasantias.map((elemento)=>{
              //Recorrer para ver si existe ID de notificaciones guardadas
              tempNoti.map((ele) => {
                  if (tempNoti.indexOf(elemento._id.trim()) === -1) {
                      tempNoti.push(elemento._id);
                  }
                  return null;
              })
              return null;
          })
          localStorage.setItem('alertaPasantiasLocal', JSON.stringify(tempNoti));
          
      }else{
          let tempNoti = [];
          dataPasantias.map((elemento, index) => {
              tempNoti.push(elemento._id);
              return null;
          })
          localStorage.setItem('alertaPasantiasLocal', JSON.stringify(tempNoti));
      }
      return null;
    }

    loadMenu();
  }, [dataUser]);

  // const pasantiaBody = (descripcion) => {
  //   return { __html: descripcion };
  // };

  const normalizar = (texto) =>
    (texto || "")
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(new RegExp("[\\u0300-\\u036f]", "g"), "")
      .trim();

  const areas = useMemo(() => {
    if (!Array.isArray(pasantias)) return [];
    return [...new Set(pasantias.map((p) => (p.area || "").trim()).filter(Boolean))].sort();
  }, [pasantias]);

  const empresas = useMemo(() => {
    if (!Array.isArray(pasantias)) return [];
    return [...new Set(pasantias.map((p) => (p.empresa || "").trim()).filter(Boolean))].sort();
  }, [pasantias]);

  const pasantiasFiltradas = useMemo(() => {
    if (!Array.isArray(pasantias)) return [];
    const texto = normalizar(busqueda);
    const estadoAplicacion = (p) => {
      const propia = (p.aplicaciones || []).find(
        (elemt) => elemt.carnet === dataUser.carnet
      );
      if (!propia) return "sin";
      return +propia.seleccionado === 1 ? "seleccionado" : "aplicada";
    };
    return pasantias.filter((p) => {
      if (texto) {
        const contenido = normalizar(`${p.titulo} ${p.empresa} ${p.area}`);
        if (contenido.indexOf(texto) === -1) return false;
      }
      if (areaFiltro && (p.area || "").trim() !== areaFiltro) return false;
      if (empresaFiltro && (p.empresa || "").trim() !== empresaFiltro) return false;
      if (aplicacionFiltro && estadoAplicacion(p) !== aplicacionFiltro) return false;
      return true;
    });
  }, [pasantias, busqueda, areaFiltro, empresaFiltro, aplicacionFiltro, dataUser.carnet]);

  const hayFiltros = busqueda !== "" || areaFiltro !== "" || empresaFiltro !== "" || aplicacionFiltro !== "";

  const limpiarFiltros = () => {
    setBusqueda("");
    setAreaFiltro("");
    setEmpresaFiltro("");
    setAplicacionFiltro("");
  };

  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <div className="footer">
            <p>
              Copyright &copy;
              {/* <script>
                                document.write(new Date().getFullYear());
                            </script> All rights reserved | This template is made with <i className="icon-heart" aria-hidden="true"></i> by <a href="https://colorlib.com" target="_blank">Colorlib.com</a> */}
            </p>
          </div>
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Pasantías</h2>
        <FacturaElectronica />
        <div className="d-flex flex-wrap justify-content-end mb-3">
          {cv === 0 ? (
            <Link className="btn btn-primary btn-sm mb-2 mr-2" to="/pasantiascv">
              <i className="fa fa-file-text-o mr-1" aria-hidden="true"></i> Subir mi CV
            </Link>
          ) : null}
          <Link className="btn btn-outline-primary btn-sm mb-2" to="/pasantiasapplyalumno">
            <i className="fa fa-check-circle-o mr-1" aria-hidden="true"></i> Mis aplicaciones
          </Link>
        </div>
        {!cargando && pasantias && pasantias.length > 0 && (
          <div className="card mb-4">
            <div className="card-body">
              <div className="form-row">
                <div className="form-group col-md-4">
                  <label htmlFor="filtro-busqueda">Buscar</label>
                  <input
                    type="text"
                    className="form-control"
                    id="filtro-busqueda"
                    placeholder="Título, empresa o área"
                    value={busqueda}
                    onChange={(e) => setBusqueda(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="filtro-empresa">Empresa</label>
                  <select
                    className="form-control"
                    id="filtro-empresa"
                    value={empresaFiltro}
                    onChange={(e) => setEmpresaFiltro(e.target.value)}
                  >
                    <option value="">Todas</option>
                    {empresas.map((empresa) => (
                      <option key={empresa} value={empresa}>{empresa}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="filtro-area">Área</label>
                  <select
                    className="form-control"
                    id="filtro-area"
                    value={areaFiltro}
                    onChange={(e) => setAreaFiltro(e.target.value)}
                  >
                    <option value="">Todas</option>
                    {areas.map((area) => (
                      <option key={area} value={area}>{area}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-2">
                  <label htmlFor="filtro-aplicacion">Mi aplicación</label>
                  <select
                    className="form-control"
                    id="filtro-aplicacion"
                    value={aplicacionFiltro}
                    onChange={(e) => setAplicacionFiltro(e.target.value)}
                  >
                    <option value="">Todas</option>
                    <option value="sin">Sin aplicar</option>
                    <option value="aplicada">Ya apliqué</option>
                    <option value="seleccionado">Seleccionado</option>
                  </select>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <small className="text-muted">
                  Mostrando <b>{pasantiasFiltradas.length}</b> de <b>{pasantias.length}</b> pasantías
                </small>
                {hayFiltros && (
                  <button type="button" className="btn btn-outline-secondary btn-sm" onClick={limpiarFiltros}>
                    <i className="fa fa-times mr-1" aria-hidden="true"></i>Limpiar filtros
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
        {cargando ? (
          <SkeletonCard rows={4} />
        ) : pasantiasFiltradas.length > 0 ? (
          pasantiasFiltradas.map((data, key) => {
            let dataPasantiaApply = data.aplicaciones;
            let aplicacionPasantia = 0;
            let seleccionadoPasantia = 0;
            dataPasantiaApply.map((elemt) => {
              return elemt.carnet === dataUser.carnet ? (aplicacionPasantia = 1) : null;
            });
            dataPasantiaApply.map((elemt) => {
              if (elemt.carnet === dataUser.carnet) {
                return +elemt.seleccionado === 1 ? seleccionadoPasantia = 1 : 0;
              }
              return 0;
            });
            return (
              <div key={data._id || key} className="card mb-3">
                <div className="card-body">
                  <div className="d-flex align-items-start justify-content-between mb-1">
                    <h5 className="card-title mb-0">{data.titulo}</h5>
                    {seleccionadoPasantia === 1 ? (
                      <span className="esen-chip esen-chip--success ml-2">
                        <i className="fa fa-check mr-1" aria-hidden="true"></i> Seleccionado
                      </span>
                    ) : aplicacionPasantia === 1 ? (
                      <span className="esen-chip esen-chip--info ml-2">
                        <i className="fa fa-check-circle-o mr-1" aria-hidden="true"></i> Ya aplicaste
                      </span>
                    ) : null}
                  </div>
                  <p className="text-muted small mb-3">
                    <i className="fa fa-building-o mr-1" aria-hidden="true"></i> {data.empresa}
                    <span className="mx-2">&middot;</span>
                    {data.area}
                  </p>
                  {seleccionadoPasantia === 1 ? (
                    <div className="alert alert-success mb-3" role="alert">
                      <i className="fa fa-thumbs-o-up mr-2" aria-hidden="true"></i>
                      <b>¡Felicidades!</b> Fuiste seleccionado para esta pasantía.
                    </div>
                  ) : null}
                  <Link
                    to={"pasantiadetalle?id_pasantia=" + data._id}
                    className="btn btn-primary btn-sm"
                  >
                    Más información
                  </Link>
                </div>
              </div>
            );
          })
        ) : pasantias && pasantias.length > 0 && hayFiltros ? (
          <EmptyState icon="fa-filter" title="Sin resultados para los filtros aplicados">
            Ajusta la búsqueda o limpia los filtros para ver todas las pasantías.
          </EmptyState>
        ) : (
          <EmptyState icon="fa-briefcase" title="Aún no hay pasantías publicadas">
            Cuando haya nuevas oportunidades de pasantía, aparecerán aquí.
          </EmptyState>
        )}
      </div>
    </div>
  );
};

export default PasantiasAlumnos;
